import React from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';


import { CssBaseline } from '@mui/material';
import ThemeSetter from 'components/common/ThemeSetter'; // Adjust path if needed


const PublicLayout = () => {
    return (
        <Box>
            {/* ===================================================================== */}
            {/* THIS IS THE NEW LOGIC */}
            {/* This one line commands the global context to use the pre-login theme */}
            {/* for any page that uses PublicLayout. */}
            <ThemeSetter mode="preLogin" />
            {/* ===================================================================== */}
            <CssBaseline />
            <main>
                <Outlet />
            </main>
        </Box>
    );
};

export default PublicLayout;